import React from 'react';
interface FooterProps {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
}
export function Footer({
  onOpenPrivacy,
  onOpenTerms
}: FooterProps) {
  return <footer className="bg-espresso text-warm-white/40 py-8 text-center text-sm" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <p className="mb-3" data-id="element-17">
          © {new Date().getFullYear()} 3 Bases, 15 Platos. Hecho con ❤️ para la
          comunidad latina.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-18">
          <button onClick={onOpenPrivacy} className="text-warm-white/40 hover:text-warm-white/80 underline underline-offset-2 transition-colors text-xs" data-id="element-19">
            Política de Privacidad
          </button>
          <span className="text-warm-white/20" data-id="element-20">·</span>
          <button onClick={onOpenTerms} className="text-warm-white/40 hover:text-warm-white/80 underline underline-offset-2 transition-colors text-xs" data-id="element-21">
            Términos y Condiciones
          </button>
        </div>
      </div>
    </footer>;
}